import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';

import './latest-press-releases.scss';

export function LatestPressReleases({ entry = DEFAULT_CONTENT }) {
  const releases = entry.children();

  if (!releases.length) {
    return null;
  }

  return (
    <section className="latest-press-releases py-2" aria-labelledby="latest-press-releases-heading">
      <h2 id="latest-press-releases-heading" className="size-24 fw-medium mb-1_5 text-gray-darker">
        {entry.title}
      </h2>
      <Row>
        {releases.map(release => {
          const {
            title,
            'link-url': rawLinkUrl,
            'article-date': articleDate,
            'media-image': mediaImage,
          } = release.getAllMetadata();
          const titleText = typeof title === 'string' ? title : '';
          const linkUrl = rawLinkUrl && !rawLinkUrl.endsWith('.html') ? `${rawLinkUrl}.html` : rawLinkUrl;
          return (
            <Col key={release.id} xs={12} md={4} className="mb-1_5">
              {!!mediaImage && !!linkUrl && (
                <Link to={linkUrl}>
                  <Image
                    imageId={mediaImage}
                    source=""
                    alt={titleText}
                    className="latest-press-releases__thumbnail mb-0"
                    lazy
                  />
                </Link>
              )}
              {!!mediaImage && !linkUrl && (
                <Image
                  imageId={mediaImage}
                  source=""
                  alt={titleText}
                  className="latest-press-releases__thumbnail mb-0"
                  lazy
                />
              )}
              <div className="mt-0_75">
                <h3 className="size-20 fw-medium text-gray-darker mb-0_25">
                  {linkUrl ? (
                    <Link to={linkUrl} className="text-gray-darker text-decoration-none">
                      {titleText}
                    </Link>
                  ) : (
                    titleText
                  )}
                </h3>
                {!!articleDate && <p className="size-16 text-gray-darker mb-0_25">Published: {articleDate}</p>}
                {!!linkUrl && (
                  <Link to={linkUrl} className="size-16 fw-bold text-blue-50 text-underline">
                    Read More
                  </Link>
                )}
              </div>
            </Col>
          );
        })}
      </Row>
    </section>
  );
}

LatestPressReleases.propTypes = {
  entry: CmsEntities.Content,
};
